// Import jQuery and assign it to the global window object
// Do this in a separate file to ensure jQuery is available globally before any other component or imports require the global jQuery
import jQuery from 'jquery'

declare global {
    interface Window {
        jQuery: JQueryStatic
        $: JQueryStatic
    }
}
window.jQuery = jQuery
window.$ = jQuery
